module.exports = __webpack_public_path__ + "img/squint_metrics_plugin.894e3d6b.svg";